exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".owl-carousel[data-v-0b6257ca]{height:calc(100% - 50px)}.item[data-v-0b6257ca],.owl-item[data-v-0b6257ca],.owl-stage-outer[data-v-0b6257ca],.owl-stage[data-v-0b6257ca]{height:100%}.item img[data-v-0b6257ca]{max-height:100%;max-width:100%;margin:0 auto;width:auto}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0b6257ca","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Help.vue
// module id = 417
// module chunks = 0